/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * BriefEngine API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInviteResult,
  AddItemsInput,
  AddItemsResponse,
  AdminAnalytics,
  BackgroundJobStatus,
  BookmarkCollection,
  Brief,
  BriefJobAccepted,
  BulkJobActionResult,
  BulkJobIdsInput,
  CollectionInput,
  Comment,
  CommentAnalysis,
  ContentItem,
  CreateWorkspaceInput,
  DeleteResult,
  EmailPreferences,
  ErrorEnvelope,
  GenerateBriefInput,
  HealthStatus,
  InviteMemberInput,
  InviteMemberResult,
  InvitePreview,
  RunVideoAnalysisParams,
  ScrapeJob,
  StartScrapeJobInput,
  SuccessResponse,
  Transcript,
  UpdateBriefInput,
  UpdateEmailPreferences,
  UpdateWorkspaceInput,
  UploadUrlRequest,
  UploadUrlResponse,
  UserAnalytics,
  VideoAnalysis,
  Workspace,
  WorkspaceInvite,
  WorkspaceMember,
  WorkspaceStats,
  WorkspacesSummary,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all workspaces
 */
export const getListWorkspacesUrl = () => {
  return `/api/workspaces`;
};

export const listWorkspaces = async (
  options?: RequestInit,
): Promise<Workspace[]> => {
  return customFetch<Workspace[]>(getListWorkspacesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListWorkspacesQueryKey = () => {
  return [`/api/workspaces`] as const;
};

export const getListWorkspacesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaces>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWorkspacesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaces>>> = ({
    signal,
  }) => listWorkspaces({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaces>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaces>>
>;
export type ListWorkspacesQueryError = ErrorType<unknown>;

/**
 * @summary List all workspaces
 */

export function useListWorkspaces<
  TData = Awaited<ReturnType<typeof listWorkspaces>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaces>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspacesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a workspace
 */
export const getCreateWorkspaceUrl = () => {
  return `/api/workspaces`;
};

export const createWorkspace = async (
  createWorkspaceInput: CreateWorkspaceInput,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getCreateWorkspaceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createWorkspaceInput),
  });
};

export const getCreateWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspace>>,
    TError,
    { data: BodyType<CreateWorkspaceInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkspace>>,
  TError,
  { data: BodyType<CreateWorkspaceInput> },
  TContext
> => {
  const mutationKey = ["createWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkspace>>,
    { data: BodyType<CreateWorkspaceInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createWorkspace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkspace>>
>;
export type CreateWorkspaceMutationBody = BodyType<CreateWorkspaceInput>;
export type CreateWorkspaceMutationError = ErrorType<unknown>;

/**
 * @summary Create a workspace
 */
export const useCreateWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkspace>>,
    TError,
    { data: BodyType<CreateWorkspaceInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWorkspace>>,
  TError,
  { data: BodyType<CreateWorkspaceInput> },
  TContext
> => {
  return useMutation(getCreateWorkspaceMutationOptions(options));
};

/**
 * Returns per-workspace activity (member count, last active timestamp, brief counts, sparkline) plus top-level totals.
 * @summary Get summary metrics for all accessible workspaces
 */
export const getGetWorkspacesSummaryUrl = () => {
  return `/api/workspaces/summary`;
};

export const getWorkspacesSummary = async (
  options?: RequestInit,
): Promise<WorkspacesSummary> => {
  return customFetch<WorkspacesSummary>(getGetWorkspacesSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspacesSummaryQueryKey = () => {
  return [`/api/workspaces/summary`] as const;
};

export const getGetWorkspacesSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspacesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspacesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkspacesSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspacesSummary>>
  > = ({ signal }) => getWorkspacesSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspacesSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspacesSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspacesSummary>>
>;
export type GetWorkspacesSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get summary metrics for all accessible workspaces
 */

export function useGetWorkspacesSummary<
  TData = Awaited<ReturnType<typeof getWorkspacesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspacesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspacesSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a workspace
 */
export const getGetWorkspaceUrl = (id: number) => {
  return `/api/workspaces/${id}`;
};

export const getWorkspace = async (
  id: number,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getGetWorkspaceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspaceQueryKey = (id: number) => {
  return [`/api/workspaces/${id}`] as const;
};

export const getGetWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkspaceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspace>>> = ({
    signal,
  }) => getWorkspace(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspace>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspace>>
>;
export type GetWorkspaceQueryError = ErrorType<void>;

/**
 * @summary Get a workspace
 */

export function useGetWorkspace<
  TData = Awaited<ReturnType<typeof getWorkspace>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a workspace
 */
export const getUpdateWorkspaceUrl = (id: number) => {
  return `/api/workspaces/${id}`;
};

export const updateWorkspace = async (
  id: number,
  updateWorkspaceInput: UpdateWorkspaceInput,
  options?: RequestInit,
): Promise<Workspace> => {
  return customFetch<Workspace>(getUpdateWorkspaceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWorkspaceInput),
  });
};

export const getUpdateWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspace>>,
    TError,
    { id: number; data: BodyType<UpdateWorkspaceInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkspace>>,
  TError,
  { id: number; data: BodyType<UpdateWorkspaceInput> },
  TContext
> => {
  const mutationKey = ["updateWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkspace>>,
    { id: number; data: BodyType<UpdateWorkspaceInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWorkspace(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWorkspace>>
>;
export type UpdateWorkspaceMutationBody = BodyType<UpdateWorkspaceInput>;
export type UpdateWorkspaceMutationError = ErrorType<unknown>;

/**
 * @summary Update a workspace
 */
export const useUpdateWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkspace>>,
    TError,
    { id: number; data: BodyType<UpdateWorkspaceInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkspace>>,
  TError,
  { id: number; data: BodyType<UpdateWorkspaceInput> },
  TContext
> => {
  return useMutation(getUpdateWorkspaceMutationOptions(options));
};

/**
 * @summary Delete a workspace
 */
export const getDeleteWorkspaceUrl = (id: number) => {
  return `/api/workspaces/${id}`;
};

export const deleteWorkspace = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getDeleteWorkspaceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteWorkspaceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspace>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkspace>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteWorkspace"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkspace>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWorkspace(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspace>>
>;

export type DeleteWorkspaceMutationError = ErrorType<unknown>;

/**
 * @summary Delete a workspace
 */
export const useDeleteWorkspace = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspace>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkspace>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteWorkspaceMutationOptions(options));
};

/**
 * @summary Get workspace stats
 */
export const getGetWorkspaceStatsUrl = (id: number) => {
  return `/api/workspaces/${id}/stats`;
};

export const getWorkspaceStats = async (
  id: number,
  options?: RequestInit,
): Promise<WorkspaceStats> => {
  return customFetch<WorkspaceStats>(getGetWorkspaceStatsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkspaceStatsQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/stats`] as const;
};

export const getGetWorkspaceStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkspaceStatsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceStats>>
  > = ({ signal }) => getWorkspaceStats(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceStats>>
>;
export type GetWorkspaceStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get workspace stats
 */

export function useGetWorkspaceStats<
  TData = Awaited<ReturnType<typeof getWorkspaceStats>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWorkspaceStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWorkspaceStatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List workspace members
 */
export const getListWorkspaceMembersUrl = (id: number) => {
  return `/api/workspaces/${id}/members`;
};

export const listWorkspaceMembers = async (
  id: number,
  options?: RequestInit,
): Promise<WorkspaceMember[]> => {
  return customFetch<WorkspaceMember[]>(getListWorkspaceMembersUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListWorkspaceMembersQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/members`] as const;
};

export const getListWorkspaceMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceMembers>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceMembers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceMembersQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceMembers>>
  > = ({ signal }) => listWorkspaceMembers(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceMembers>>
>;
export type ListWorkspaceMembersQueryError = ErrorType<unknown>;

/**
 * @summary List workspace members
 */

export function useListWorkspaceMembers<
  TData = Awaited<ReturnType<typeof listWorkspaceMembers>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceMembers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceMembersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * If the email belongs to an existing ViraLens user, they are added to the workspace
immediately. Otherwise a pending invite is created and a sign-up + auto-join email
is sent via Resend. Inspect the `pending` field on the response to know which case
occurred.

 * @summary Invite a member by email
 */
export const getInviteWorkspaceMemberUrl = (id: number) => {
  return `/api/workspaces/${id}/members`;
};

export const inviteWorkspaceMember = async (
  id: number,
  inviteMemberInput: InviteMemberInput,
  options?: RequestInit,
): Promise<InviteMemberResult> => {
  return customFetch<InviteMemberResult>(getInviteWorkspaceMemberUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteMemberInput),
  });
};

export const getInviteWorkspaceMemberMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteWorkspaceMember>>,
    TError,
    { id: number; data: BodyType<InviteMemberInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteWorkspaceMember>>,
  TError,
  { id: number; data: BodyType<InviteMemberInput> },
  TContext
> => {
  const mutationKey = ["inviteWorkspaceMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteWorkspaceMember>>,
    { id: number; data: BodyType<InviteMemberInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return inviteWorkspaceMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteWorkspaceMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteWorkspaceMember>>
>;
export type InviteWorkspaceMemberMutationBody = BodyType<InviteMemberInput>;
export type InviteWorkspaceMemberMutationError = ErrorType<void>;

/**
 * @summary Invite a member by email
 */
export const useInviteWorkspaceMember = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteWorkspaceMember>>,
    TError,
    { id: number; data: BodyType<InviteMemberInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inviteWorkspaceMember>>,
  TError,
  { id: number; data: BodyType<InviteMemberInput> },
  TContext
> => {
  return useMutation(getInviteWorkspaceMemberMutationOptions(options));
};

/**
 * @summary List pending (unaccepted, unexpired) workspace invites
 */
export const getListWorkspaceInvitesUrl = (id: number) => {
  return `/api/workspaces/${id}/invites`;
};

export const listWorkspaceInvites = async (
  id: number,
  options?: RequestInit,
): Promise<WorkspaceInvite[]> => {
  return customFetch<WorkspaceInvite[]>(getListWorkspaceInvitesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListWorkspaceInvitesQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/invites`] as const;
};

export const getListWorkspaceInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceInvites>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceInvites>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceInvitesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceInvites>>
  > = ({ signal }) => listWorkspaceInvites(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceInvites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceInvitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceInvites>>
>;
export type ListWorkspaceInvitesQueryError = ErrorType<unknown>;

/**
 * @summary List pending (unaccepted, unexpired) workspace invites
 */

export function useListWorkspaceInvites<
  TData = Awaited<ReturnType<typeof listWorkspaceInvites>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceInvites>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceInvitesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Revoke a pending invite
 */
export const getRevokeWorkspaceInviteUrl = (id: number, inviteId: number) => {
  return `/api/workspaces/${id}/invites/${inviteId}`;
};

export const revokeWorkspaceInvite = async (
  id: number,
  inviteId: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getRevokeWorkspaceInviteUrl(id, inviteId), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeWorkspaceInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeWorkspaceInvite>>,
    TError,
    { id: number; inviteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeWorkspaceInvite>>,
  TError,
  { id: number; inviteId: number },
  TContext
> => {
  const mutationKey = ["revokeWorkspaceInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeWorkspaceInvite>>,
    { id: number; inviteId: number }
  > = (props) => {
    const { id, inviteId } = props ?? {};

    return revokeWorkspaceInvite(id, inviteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeWorkspaceInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeWorkspaceInvite>>
>;

export type RevokeWorkspaceInviteMutationError = ErrorType<void>;

/**
 * @summary Revoke a pending invite
 */
export const useRevokeWorkspaceInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeWorkspaceInvite>>,
    TError,
    { id: number; inviteId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeWorkspaceInvite>>,
  TError,
  { id: number; inviteId: number },
  TContext
> => {
  return useMutation(getRevokeWorkspaceInviteMutationOptions(options));
};

/**
 * @summary Look up an invite by its token (used by the join page)
 */
export const getGetInviteByTokenUrl = (token: string) => {
  return `/api/invites/${token}`;
};

export const getInviteByToken = async (
  token: string,
  options?: RequestInit,
): Promise<InvitePreview> => {
  return customFetch<InvitePreview>(getGetInviteByTokenUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetInviteByTokenQueryKey = (token: string) => {
  return [`/api/invites/${token}`] as const;
};

export const getGetInviteByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getInviteByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInviteByTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInviteByToken>>
  > = ({ signal }) => getInviteByToken(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInviteByToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInviteByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInviteByToken>>
>;
export type GetInviteByTokenQueryError = ErrorType<void>;

/**
 * @summary Look up an invite by its token (used by the join page)
 */

export function useGetInviteByToken<
  TData = Awaited<ReturnType<typeof getInviteByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInviteByTokenQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Accept an invite as the currently authenticated user
 */
export const getAcceptWorkspaceInviteUrl = (token: string) => {
  return `/api/invites/${token}/accept`;
};

export const acceptWorkspaceInvite = async (
  token: string,
  options?: RequestInit,
): Promise<AcceptInviteResult> => {
  return customFetch<AcceptInviteResult>(getAcceptWorkspaceInviteUrl(token), {
    ...options,
    method: "POST",
  });
};

export const getAcceptWorkspaceInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptWorkspaceInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptWorkspaceInvite>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["acceptWorkspaceInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptWorkspaceInvite>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return acceptWorkspaceInvite(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptWorkspaceInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptWorkspaceInvite>>
>;

export type AcceptWorkspaceInviteMutationError = ErrorType<void>;

/**
 * @summary Accept an invite as the currently authenticated user
 */
export const useAcceptWorkspaceInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptWorkspaceInvite>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptWorkspaceInvite>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getAcceptWorkspaceInviteMutationOptions(options));
};

/**
 * @summary Remove a workspace member
 */
export const getRemoveWorkspaceMemberUrl = (id: number, userId: number) => {
  return `/api/workspaces/${id}/members/${userId}`;
};

export const removeWorkspaceMember = async (
  id: number,
  userId: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getRemoveWorkspaceMemberUrl(id, userId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveWorkspaceMemberMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceMember>>,
    TError,
    { id: number; userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeWorkspaceMember>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  const mutationKey = ["removeWorkspaceMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeWorkspaceMember>>,
    { id: number; userId: number }
  > = (props) => {
    const { id, userId } = props ?? {};

    return removeWorkspaceMember(id, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveWorkspaceMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeWorkspaceMember>>
>;

export type RemoveWorkspaceMemberMutationError = ErrorType<void>;

/**
 * @summary Remove a workspace member
 */
export const useRemoveWorkspaceMember = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeWorkspaceMember>>,
    TError,
    { id: number; userId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeWorkspaceMember>>,
  TError,
  { id: number; userId: number },
  TContext
> => {
  return useMutation(getRemoveWorkspaceMemberMutationOptions(options));
};

/**
 * @summary List scrape jobs for a workspace
 */
export const getListWorkspaceJobsUrl = (id: number) => {
  return `/api/workspaces/${id}/jobs`;
};

export const listWorkspaceJobs = async (
  id: number,
  options?: RequestInit,
): Promise<ScrapeJob[]> => {
  return customFetch<ScrapeJob[]>(getListWorkspaceJobsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListWorkspaceJobsQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/jobs`] as const;
};

export const getListWorkspaceJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceJobs>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWorkspaceJobsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceJobs>>
  > = ({ signal }) => listWorkspaceJobs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceJobs>>
>;
export type ListWorkspaceJobsQueryError = ErrorType<unknown>;

/**
 * @summary List scrape jobs for a workspace
 */

export function useListWorkspaceJobs<
  TData = Awaited<ReturnType<typeof listWorkspaceJobs>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceJobsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Start a new scrape job
 */
export const getStartScrapeJobUrl = (id: number) => {
  return `/api/workspaces/${id}/jobs`;
};

export const startScrapeJob = async (
  id: number,
  startScrapeJobInput: StartScrapeJobInput,
  options?: RequestInit,
): Promise<ScrapeJob> => {
  return customFetch<ScrapeJob>(getStartScrapeJobUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(startScrapeJobInput),
  });
};

export const getStartScrapeJobMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startScrapeJob>>,
    TError,
    { id: number; data: BodyType<StartScrapeJobInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startScrapeJob>>,
  TError,
  { id: number; data: BodyType<StartScrapeJobInput> },
  TContext
> => {
  const mutationKey = ["startScrapeJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startScrapeJob>>,
    { id: number; data: BodyType<StartScrapeJobInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return startScrapeJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartScrapeJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof startScrapeJob>>
>;
export type StartScrapeJobMutationBody = BodyType<StartScrapeJobInput>;
export type StartScrapeJobMutationError = ErrorType<unknown>;

/**
 * @summary Start a new scrape job
 */
export const useStartScrapeJob = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startScrapeJob>>,
    TError,
    { id: number; data: BodyType<StartScrapeJobInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startScrapeJob>>,
  TError,
  { id: number; data: BodyType<StartScrapeJobInput> },
  TContext
> => {
  return useMutation(getStartScrapeJobMutationOptions(options));
};

/**
 * @summary Pin multiple scrape jobs in one request
 */
export const getBulkPinJobsUrl = (id: number) => {
  return `/api/workspaces/${id}/jobs/bulk-pin`;
};

export const bulkPinJobs = async (
  id: number,
  bulkJobIdsInput: BulkJobIdsInput,
  options?: RequestInit,
): Promise<BulkJobActionResult> => {
  return customFetch<BulkJobActionResult>(getBulkPinJobsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkJobIdsInput),
  });
};

export const getBulkPinJobsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPinJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPinJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  const mutationKey = ["bulkPinJobs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPinJobs>>,
    { id: number; data: BodyType<BulkJobIdsInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return bulkPinJobs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPinJobsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPinJobs>>
>;
export type BulkPinJobsMutationBody = BodyType<BulkJobIdsInput>;
export type BulkPinJobsMutationError = ErrorType<unknown>;

/**
 * @summary Pin multiple scrape jobs in one request
 */
export const useBulkPinJobs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPinJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPinJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  return useMutation(getBulkPinJobsMutationOptions(options));
};

/**
 * @summary Unpin multiple scrape jobs in one request
 */
export const getBulkUnpinJobsUrl = (id: number) => {
  return `/api/workspaces/${id}/jobs/bulk-unpin`;
};

export const bulkUnpinJobs = async (
  id: number,
  bulkJobIdsInput: BulkJobIdsInput,
  options?: RequestInit,
): Promise<BulkJobActionResult> => {
  return customFetch<BulkJobActionResult>(getBulkUnpinJobsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkJobIdsInput),
  });
};

export const getBulkUnpinJobsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUnpinJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUnpinJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  const mutationKey = ["bulkUnpinJobs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUnpinJobs>>,
    { id: number; data: BodyType<BulkJobIdsInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return bulkUnpinJobs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUnpinJobsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUnpinJobs>>
>;
export type BulkUnpinJobsMutationBody = BodyType<BulkJobIdsInput>;
export type BulkUnpinJobsMutationError = ErrorType<unknown>;

/**
 * @summary Unpin multiple scrape jobs in one request
 */
export const useBulkUnpinJobs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUnpinJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkUnpinJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  return useMutation(getBulkUnpinJobsMutationOptions(options));
};

/**
 * @summary Soft-delete multiple scrape jobs in one request
 */
export const getBulkDeleteJobsUrl = (id: number) => {
  return `/api/workspaces/${id}/jobs/bulk-delete`;
};

export const bulkDeleteJobs = async (
  id: number,
  bulkJobIdsInput: BulkJobIdsInput,
  options?: RequestInit,
): Promise<BulkJobActionResult> => {
  return customFetch<BulkJobActionResult>(getBulkDeleteJobsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkJobIdsInput),
  });
};

export const getBulkDeleteJobsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  const mutationKey = ["bulkDeleteJobs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteJobs>>,
    { id: number; data: BodyType<BulkJobIdsInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return bulkDeleteJobs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteJobsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteJobs>>
>;
export type BulkDeleteJobsMutationBody = BodyType<BulkJobIdsInput>;
export type BulkDeleteJobsMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete multiple scrape jobs in one request
 */
export const useBulkDeleteJobs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteJobs>>,
    TError,
    { id: number; data: BodyType<BulkJobIdsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteJobs>>,
  TError,
  { id: number; data: BodyType<BulkJobIdsInput> },
  TContext
> => {
  return useMutation(getBulkDeleteJobsMutationOptions(options));
};

/**
 * @summary List all content items for a workspace
 */
export const getListWorkspaceContentUrl = (id: number) => {
  return `/api/workspaces/${id}/content`;
};

export const listWorkspaceContent = async (
  id: number,
  options?: RequestInit,
): Promise<ContentItem[]> => {
  return customFetch<ContentItem[]>(getListWorkspaceContentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListWorkspaceContentQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/content`] as const;
};

export const getListWorkspaceContentQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceContent>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceContent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWorkspaceContentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceContent>>
  > = ({ signal }) => listWorkspaceContent(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceContent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWorkspaceContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceContent>>
>;
export type ListWorkspaceContentQueryError = ErrorType<unknown>;

/**
 * @summary List all content items for a workspace
 */

export function useListWorkspaceContent<
  TData = Awaited<ReturnType<typeof listWorkspaceContent>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWorkspaceContent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWorkspaceContentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List bookmarked items for a workspace
 */
export const getListBookmarksUrl = (id: number) => {
  return `/api/workspaces/${id}/bookmarks`;
};

export const listBookmarks = async (
  id: number,
  options?: RequestInit,
): Promise<ContentItem[]> => {
  return customFetch<ContentItem[]>(getListBookmarksUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListBookmarksQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/bookmarks`] as const;
};

export const getListBookmarksQueryOptions = <
  TData = Awaited<ReturnType<typeof listBookmarks>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBookmarks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBookmarksQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBookmarks>>> = ({
    signal,
  }) => listBookmarks(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBookmarks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBookmarksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBookmarks>>
>;
export type ListBookmarksQueryError = ErrorType<unknown>;

/**
 * @summary List bookmarked items for a workspace
 */

export function useListBookmarks<
  TData = Awaited<ReturnType<typeof listBookmarks>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBookmarks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBookmarksQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List briefs for a workspace
 */
export const getListBriefsUrl = (id: number) => {
  return `/api/workspaces/${id}/briefs`;
};

export const listBriefs = async (
  id: number,
  options?: RequestInit,
): Promise<Brief[]> => {
  return customFetch<Brief[]>(getListBriefsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListBriefsQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/briefs`] as const;
};

export const getListBriefsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBriefs>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBriefs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBriefsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBriefs>>> = ({
    signal,
  }) => listBriefs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBriefs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBriefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBriefs>>
>;
export type ListBriefsQueryError = ErrorType<unknown>;

/**
 * @summary List briefs for a workspace
 */

export function useListBriefs<
  TData = Awaited<ReturnType<typeof listBriefs>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBriefs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBriefsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate a creative brief
 */
export const getGenerateBriefUrl = (id: number) => {
  return `/api/workspaces/${id}/briefs`;
};

export const generateBrief = async (
  id: number,
  generateBriefInput: GenerateBriefInput,
  options?: RequestInit,
): Promise<BriefJobAccepted> => {
  return customFetch<BriefJobAccepted>(getGenerateBriefUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateBriefInput),
  });
};

export const getGenerateBriefMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBrief>>,
    TError,
    { id: number; data: BodyType<GenerateBriefInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateBrief>>,
  TError,
  { id: number; data: BodyType<GenerateBriefInput> },
  TContext
> => {
  const mutationKey = ["generateBrief"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateBrief>>,
    { id: number; data: BodyType<GenerateBriefInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateBrief(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateBrief>>
>;
export type GenerateBriefMutationBody = BodyType<GenerateBriefInput>;
export type GenerateBriefMutationError = ErrorType<unknown>;

/**
 * @summary Generate a creative brief
 */
export const useGenerateBrief = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateBrief>>,
    TError,
    { id: number; data: BodyType<GenerateBriefInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateBrief>>,
  TError,
  { id: number; data: BodyType<GenerateBriefInput> },
  TContext
> => {
  return useMutation(getGenerateBriefMutationOptions(options));
};

/**
 * @summary List bookmark collections in a workspace
 */
export const getListCollectionsUrl = (id: number) => {
  return `/api/workspaces/${id}/collections`;
};

export const listCollections = async (
  id: number,
  options?: RequestInit,
): Promise<BookmarkCollection[]> => {
  return customFetch<BookmarkCollection[]>(getListCollectionsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListCollectionsQueryKey = (id: number) => {
  return [`/api/workspaces/${id}/collections`] as const;
};

export const getListCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCollections>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCollectionsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollections>>> = ({
    signal,
  }) => listCollections(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCollections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCollections>>
>;
export type ListCollectionsQueryError = ErrorType<unknown>;

/**
 * @summary List bookmark collections in a workspace
 */

export function useListCollections<
  TData = Awaited<ReturnType<typeof listCollections>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCollections>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCollectionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a bookmark collection
 */
export const getCreateCollectionUrl = (id: number) => {
  return `/api/workspaces/${id}/collections`;
};

export const createCollection = async (
  id: number,
  collectionInput: CollectionInput,
  options?: RequestInit,
): Promise<BookmarkCollection> => {
  return customFetch<BookmarkCollection>(getCreateCollectionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(collectionInput),
  });
};

export const getCreateCollectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCollection>>,
    TError,
    { id: number; data: BodyType<CollectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCollection>>,
  TError,
  { id: number; data: BodyType<CollectionInput> },
  TContext
> => {
  const mutationKey = ["createCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCollection>>,
    { id: number; data: BodyType<CollectionInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createCollection(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCollection>>
>;
export type CreateCollectionMutationBody = BodyType<CollectionInput>;
export type CreateCollectionMutationError = ErrorType<unknown>;

/**
 * @summary Create a bookmark collection
 */
export const useCreateCollection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCollection>>,
    TError,
    { id: number; data: BodyType<CollectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCollection>>,
  TError,
  { id: number; data: BodyType<CollectionInput> },
  TContext
> => {
  return useMutation(getCreateCollectionMutationOptions(options));
};

/**
 * @summary Rename a bookmark collection
 */
export const getUpdateCollectionUrl = (id: number) => {
  return `/api/collections/${id}`;
};

export const updateCollection = async (
  id: number,
  collectionInput: CollectionInput,
  options?: RequestInit,
): Promise<BookmarkCollection> => {
  return customFetch<BookmarkCollection>(getUpdateCollectionUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(collectionInput),
  });
};

export const getUpdateCollectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollection>>,
    TError,
    { id: number; data: BodyType<CollectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCollection>>,
  TError,
  { id: number; data: BodyType<CollectionInput> },
  TContext
> => {
  const mutationKey = ["updateCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCollection>>,
    { id: number; data: BodyType<CollectionInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCollection(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCollection>>
>;
export type UpdateCollectionMutationBody = BodyType<CollectionInput>;
export type UpdateCollectionMutationError = ErrorType<unknown>;

/**
 * @summary Rename a bookmark collection
 */
export const useUpdateCollection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCollection>>,
    TError,
    { id: number; data: BodyType<CollectionInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCollection>>,
  TError,
  { id: number; data: BodyType<CollectionInput> },
  TContext
> => {
  return useMutation(getUpdateCollectionMutationOptions(options));
};

/**
 * @summary Delete a bookmark collection
 */
export const getDeleteCollectionUrl = (id: number) => {
  return `/api/collections/${id}`;
};

export const deleteCollection = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteCollectionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCollectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCollection>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCollection>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCollection(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCollection>>
>;

export type DeleteCollectionMutationError = ErrorType<unknown>;

/**
 * @summary Delete a bookmark collection
 */
export const useDeleteCollection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCollection>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCollection>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCollectionMutationOptions(options));
};

/**
 * @summary Add bookmark items to a collection
 */
export const getAddItemsToCollectionUrl = (id: number) => {
  return `/api/collections/${id}/items`;
};

export const addItemsToCollection = async (
  id: number,
  addItemsInput: AddItemsInput,
  options?: RequestInit,
): Promise<AddItemsResponse> => {
  return customFetch<AddItemsResponse>(getAddItemsToCollectionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addItemsInput),
  });
};

export const getAddItemsToCollectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItemsToCollection>>,
    TError,
    { id: number; data: BodyType<AddItemsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addItemsToCollection>>,
  TError,
  { id: number; data: BodyType<AddItemsInput> },
  TContext
> => {
  const mutationKey = ["addItemsToCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addItemsToCollection>>,
    { id: number; data: BodyType<AddItemsInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addItemsToCollection(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddItemsToCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addItemsToCollection>>
>;
export type AddItemsToCollectionMutationBody = BodyType<AddItemsInput>;
export type AddItemsToCollectionMutationError = ErrorType<unknown>;

/**
 * @summary Add bookmark items to a collection
 */
export const useAddItemsToCollection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItemsToCollection>>,
    TError,
    { id: number; data: BodyType<AddItemsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addItemsToCollection>>,
  TError,
  { id: number; data: BodyType<AddItemsInput> },
  TContext
> => {
  return useMutation(getAddItemsToCollectionMutationOptions(options));
};

/**
 * @summary Remove an item from a collection
 */
export const getRemoveItemFromCollectionUrl = (id: number, itemId: number) => {
  return `/api/collections/${id}/items/${itemId}`;
};

export const removeItemFromCollection = async (
  id: number,
  itemId: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getRemoveItemFromCollectionUrl(id, itemId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveItemFromCollectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeItemFromCollection>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeItemFromCollection>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  const mutationKey = ["removeItemFromCollection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeItemFromCollection>>,
    { id: number; itemId: number }
  > = (props) => {
    const { id, itemId } = props ?? {};

    return removeItemFromCollection(id, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveItemFromCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeItemFromCollection>>
>;

export type RemoveItemFromCollectionMutationError = ErrorType<unknown>;

/**
 * @summary Remove an item from a collection
 */
export const useRemoveItemFromCollection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeItemFromCollection>>,
    TError,
    { id: number; itemId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeItemFromCollection>>,
  TError,
  { id: number; itemId: number },
  TContext
> => {
  return useMutation(getRemoveItemFromCollectionMutationOptions(options));
};

/**
 * @summary Get results for a scrape job
 */
export const getGetJobResultsUrl = (jobId: number) => {
  return `/api/jobs/${jobId}/results`;
};

export const getJobResults = async (
  jobId: number,
  options?: RequestInit,
): Promise<ContentItem[]> => {
  return customFetch<ContentItem[]>(getGetJobResultsUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getGetJobResultsQueryKey = (jobId: number) => {
  return [`/api/jobs/${jobId}/results`] as const;
};

export const getGetJobResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobResults>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobResultsQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobResults>>> = ({
    signal,
  }) => getJobResults(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobResults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobResults>>
>;
export type GetJobResultsQueryError = ErrorType<unknown>;

/**
 * @summary Get results for a scrape job
 */

export function useGetJobResults<
  TData = Awaited<ReturnType<typeof getJobResults>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobResultsQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a background job status (owner-only)
 */
export const getGetBackgroundJobUrl = (id: number) => {
  return `/api/background-jobs/${id}`;
};

export const getBackgroundJob = async (
  id: number,
  options?: RequestInit,
): Promise<BackgroundJobStatus> => {
  return customFetch<BackgroundJobStatus>(getGetBackgroundJobUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetBackgroundJobQueryKey = (id: number) => {
  return [`/api/background-jobs/${id}`] as const;
};

export const getGetBackgroundJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackgroundJob>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackgroundJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackgroundJobQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackgroundJob>>
  > = ({ signal }) => getBackgroundJob(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackgroundJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackgroundJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackgroundJob>>
>;
export type GetBackgroundJobQueryError = ErrorType<unknown>;

/**
 * @summary Get a background job status (owner-only)
 */

export function useGetBackgroundJob<
  TData = Awaited<ReturnType<typeof getBackgroundJob>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackgroundJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackgroundJobQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a scrape job
 */
export const getGetScrapeJobUrl = (jobId: number) => {
  return `/api/jobs/${jobId}`;
};

export const getScrapeJob = async (
  jobId: number,
  options?: RequestInit,
): Promise<ScrapeJob> => {
  return customFetch<ScrapeJob>(getGetScrapeJobUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getGetScrapeJobQueryKey = (jobId: number) => {
  return [`/api/jobs/${jobId}`] as const;
};

export const getGetScrapeJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getScrapeJob>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScrapeJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScrapeJobQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScrapeJob>>> = ({
    signal,
  }) => getScrapeJob(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getScrapeJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetScrapeJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScrapeJob>>
>;
export type GetScrapeJobQueryError = ErrorType<unknown>;

/**
 * @summary Get a scrape job
 */

export function useGetScrapeJob<
  TData = Awaited<ReturnType<typeof getScrapeJob>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getScrapeJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetScrapeJobQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Toggle bookmark on a content item
 */
export const getToggleBookmarkUrl = (id: number) => {
  return `/api/content/${id}/bookmark`;
};

export const toggleBookmark = async (
  id: number,
  options?: RequestInit,
): Promise<ContentItem> => {
  return customFetch<ContentItem>(getToggleBookmarkUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getToggleBookmarkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleBookmark>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleBookmark>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["toggleBookmark"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleBookmark>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return toggleBookmark(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleBookmark>>
>;

export type ToggleBookmarkMutationError = ErrorType<unknown>;

/**
 * @summary Toggle bookmark on a content item
 */
export const useToggleBookmark = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleBookmark>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof toggleBookmark>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getToggleBookmarkMutationOptions(options));
};

/**
 * @summary Get video analysis for a content item
 */
export const getGetVideoAnalysisUrl = (id: number) => {
  return `/api/content/${id}/analysis`;
};

export const getVideoAnalysis = async (
  id: number,
  options?: RequestInit,
): Promise<VideoAnalysis> => {
  return customFetch<VideoAnalysis>(getGetVideoAnalysisUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVideoAnalysisQueryKey = (id: number) => {
  return [`/api/content/${id}/analysis`] as const;
};

export const getGetVideoAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideoAnalysis>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVideoAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVideoAnalysisQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideoAnalysis>>
  > = ({ signal }) => getVideoAnalysis(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideoAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVideoAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideoAnalysis>>
>;
export type GetVideoAnalysisQueryError = ErrorType<void>;

/**
 * @summary Get video analysis for a content item
 */

export function useGetVideoAnalysis<
  TData = Awaited<ReturnType<typeof getVideoAnalysis>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVideoAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVideoAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run video analysis for a content item
 */
export const getRunVideoAnalysisUrl = (
  id: number,
  params?: RunVideoAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/content/${id}/analysis?${stringifiedParams}`
    : `/api/content/${id}/analysis`;
};

export const runVideoAnalysis = async (
  id: number,
  params?: RunVideoAnalysisParams,
  options?: RequestInit,
): Promise<VideoAnalysis> => {
  return customFetch<VideoAnalysis>(getRunVideoAnalysisUrl(id, params), {
    ...options,
    method: "POST",
  });
};

export const getRunVideoAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runVideoAnalysis>>,
    TError,
    { id: number; params?: RunVideoAnalysisParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runVideoAnalysis>>,
  TError,
  { id: number; params?: RunVideoAnalysisParams },
  TContext
> => {
  const mutationKey = ["runVideoAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runVideoAnalysis>>,
    { id: number; params?: RunVideoAnalysisParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return runVideoAnalysis(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunVideoAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof runVideoAnalysis>>
>;

export type RunVideoAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary Run video analysis for a content item
 */
export const useRunVideoAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runVideoAnalysis>>,
    TError,
    { id: number; params?: RunVideoAnalysisParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runVideoAnalysis>>,
  TError,
  { id: number; params?: RunVideoAnalysisParams },
  TContext
> => {
  return useMutation(getRunVideoAnalysisMutationOptions(options));
};

/**
 * @summary Get comment analysis for a content item
 */
export const getGetCommentAnalysisUrl = (id: number) => {
  return `/api/content/${id}/comment-analysis`;
};

export const getCommentAnalysis = async (
  id: number,
  options?: RequestInit,
): Promise<CommentAnalysis> => {
  return customFetch<CommentAnalysis>(getGetCommentAnalysisUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCommentAnalysisQueryKey = (id: number) => {
  return [`/api/content/${id}/comment-analysis`] as const;
};

export const getGetCommentAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommentAnalysis>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommentAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommentAnalysisQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCommentAnalysis>>
  > = ({ signal }) => getCommentAnalysis(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommentAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommentAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommentAnalysis>>
>;
export type GetCommentAnalysisQueryError = ErrorType<void>;

/**
 * @summary Get comment analysis for a content item
 */

export function useGetCommentAnalysis<
  TData = Awaited<ReturnType<typeof getCommentAnalysis>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommentAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCommentAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run comment analysis for a content item
 */
export const getRunCommentAnalysisUrl = (id: number) => {
  return `/api/content/${id}/comment-analysis`;
};

export const runCommentAnalysis = async (
  id: number,
  options?: RequestInit,
): Promise<CommentAnalysis> => {
  return customFetch<CommentAnalysis>(getRunCommentAnalysisUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRunCommentAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCommentAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCommentAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["runCommentAnalysis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCommentAnalysis>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return runCommentAnalysis(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCommentAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCommentAnalysis>>
>;

export type RunCommentAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary Run comment analysis for a content item
 */
export const useRunCommentAnalysis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCommentAnalysis>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runCommentAnalysis>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRunCommentAnalysisMutationOptions(options));
};

/**
 * @summary Get transcript for a content item
 */
export const getGetTranscriptUrl = (id: number) => {
  return `/api/content/${id}/transcript`;
};

export const getTranscript = async (
  id: number,
  options?: RequestInit,
): Promise<Transcript> => {
  return customFetch<Transcript>(getGetTranscriptUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTranscriptQueryKey = (id: number) => {
  return [`/api/content/${id}/transcript`] as const;
};

export const getGetTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTranscript>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranscriptQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranscript>>> = ({
    signal,
  }) => getTranscript(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranscript>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTranscriptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranscript>>
>;
export type GetTranscriptQueryError = ErrorType<void>;

/**
 * @summary Get transcript for a content item
 */

export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTranscript>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTranscriptQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get comments for a content item
 */
export const getGetCommentsUrl = (id: number) => {
  return `/api/content/${id}/comments`;
};

export const getComments = async (
  id: number,
  options?: RequestInit,
): Promise<Comment[]> => {
  return customFetch<Comment[]>(getGetCommentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCommentsQueryKey = (id: number) => {
  return [`/api/content/${id}/comments`] as const;
};

export const getGetCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getComments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommentsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getComments>>> = ({
    signal,
  }) => getComments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getComments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getComments>>
>;
export type GetCommentsQueryError = ErrorType<unknown>;

/**
 * @summary Get comments for a content item
 */

export function useGetComments<
  TData = Awaited<ReturnType<typeof getComments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCommentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download brief as PDF
 */
export const getDownloadBriefPdfUrl = (id: number) => {
  return `/api/briefs/${id}/pdf`;
};

export const downloadBriefPdf = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadBriefPdfUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadBriefPdfQueryKey = (id: number) => {
  return [`/api/briefs/${id}/pdf`] as const;
};

export const getDownloadBriefPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBriefPdf>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBriefPdf>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadBriefPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadBriefPdf>>
  > = ({ signal }) => downloadBriefPdf(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadBriefPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadBriefPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBriefPdf>>
>;
export type DownloadBriefPdfQueryError = ErrorType<void>;

/**
 * @summary Download brief as PDF
 */

export function useDownloadBriefPdf<
  TData = Awaited<ReturnType<typeof downloadBriefPdf>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBriefPdf>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadBriefPdfQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a brief's title and content
 */
export const getUpdateBriefUrl = (id: number) => {
  return `/api/briefs/${id}`;
};

export const updateBrief = async (
  id: number,
  updateBriefInput: UpdateBriefInput,
  options?: RequestInit,
): Promise<Brief> => {
  return customFetch<Brief>(getUpdateBriefUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBriefInput),
  });
};

export const getUpdateBriefMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBrief>>,
    TError,
    { id: number; data: BodyType<UpdateBriefInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBrief>>,
  TError,
  { id: number; data: BodyType<UpdateBriefInput> },
  TContext
> => {
  const mutationKey = ["updateBrief"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBrief>>,
    { id: number; data: BodyType<UpdateBriefInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBrief(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBrief>>
>;
export type UpdateBriefMutationBody = BodyType<UpdateBriefInput>;
export type UpdateBriefMutationError = ErrorType<void>;

/**
 * @summary Update a brief's title and content
 */
export const useUpdateBrief = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBrief>>,
    TError,
    { id: number; data: BodyType<UpdateBriefInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBrief>>,
  TError,
  { id: number; data: BodyType<UpdateBriefInput> },
  TContext
> => {
  return useMutation(getUpdateBriefMutationOptions(options));
};

/**
 * @summary Delete a brief
 */
export const getDeleteBriefUrl = (id: number) => {
  return `/api/briefs/${id}`;
};

export const deleteBrief = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResult> => {
  return customFetch<DeleteResult>(getDeleteBriefUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBriefMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBrief>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBrief>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteBrief"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBrief>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBrief(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBrief>>
>;

export type DeleteBriefMutationError = ErrorType<unknown>;

/**
 * @summary Delete a brief
 */
export const useDeleteBrief = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBrief>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBrief>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBriefMutationOptions(options));
};

/**
 * @summary Get user usage analytics for last 30 days
 */
export const getGetAnalyticsUsageUrl = () => {
  return `/api/analytics/usage`;
};

export const getAnalyticsUsage = async (
  options?: RequestInit,
): Promise<UserAnalytics> => {
  return customFetch<UserAnalytics>(getGetAnalyticsUsageUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAnalyticsUsageQueryKey = () => {
  return [`/api/analytics/usage`] as const;
};

export const getGetAnalyticsUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsUsage>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsUsage>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsUsageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnalyticsUsage>>
  > = ({ signal }) => getAnalyticsUsage({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAnalyticsUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsUsage>>
>;
export type GetAnalyticsUsageQueryError = ErrorType<void>;

/**
 * @summary Get user usage analytics for last 30 days
 */

export function useGetAnalyticsUsage<
  TData = Awaited<ReturnType<typeof getAnalyticsUsage>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsUsage>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAnalyticsUsageQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get admin platform analytics for last 30 days
 */
export const getGetAdminAnalyticsUrl = () => {
  return `/api/admin/analytics`;
};

export const getAdminAnalytics = async (
  options?: RequestInit,
): Promise<AdminAnalytics> => {
  return customFetch<AdminAnalytics>(getGetAdminAnalyticsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminAnalyticsQueryKey = () => {
  return [`/api/admin/analytics`] as const;
};

export const getGetAdminAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAnalytics>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAnalytics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminAnalyticsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAnalytics>>
  > = ({ signal }) => getAdminAnalytics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAnalytics>>
>;
export type GetAdminAnalyticsQueryError = ErrorType<void>;

/**
 * @summary Get admin platform analytics for last 30 days
 */

export function useGetAdminAnalytics<
  TData = Awaited<ReturnType<typeof getAdminAnalytics>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAnalytics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminAnalyticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the current user's email notification preferences
 * @summary Get email notification preferences
 */
export const getGetEmailPreferencesUrl = () => {
  return `/api/email-preferences`;
};

export const getEmailPreferences = async (
  options?: RequestInit,
): Promise<EmailPreferences> => {
  return customFetch<EmailPreferences>(getGetEmailPreferencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailPreferencesQueryKey = () => {
  return [`/api/email-preferences`] as const;
};

export const getGetEmailPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailPreferences>>
  > = ({ signal }) => getEmailPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailPreferences>>
>;
export type GetEmailPreferencesQueryError = ErrorType<void>;

/**
 * @summary Get email notification preferences
 */

export function useGetEmailPreferences<
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Toggle individual email notification types on or off
 * @summary Update email notification preferences
 */
export const getUpdateEmailPreferencesUrl = () => {
  return `/api/email-preferences`;
};

export const updateEmailPreferences = async (
  updateEmailPreferences: UpdateEmailPreferences,
  options?: RequestInit,
): Promise<EmailPreferences> => {
  return customFetch<EmailPreferences>(getUpdateEmailPreferencesUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailPreferences),
  });
};

export const getUpdateEmailPreferencesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    TError,
    { data: BodyType<UpdateEmailPreferences> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailPreferences>>,
  TError,
  { data: BodyType<UpdateEmailPreferences> },
  TContext
> => {
  const mutationKey = ["updateEmailPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    { data: BodyType<UpdateEmailPreferences> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailPreferences>>
>;
export type UpdateEmailPreferencesMutationBody =
  BodyType<UpdateEmailPreferences>;
export type UpdateEmailPreferencesMutationError = ErrorType<void>;

/**
 * @summary Update email notification preferences
 */
export const useUpdateEmailPreferences = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    TError,
    { data: BodyType<UpdateEmailPreferences> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailPreferences>>,
  TError,
  { data: BodyType<UpdateEmailPreferences> },
  TContext
> => {
  return useMutation(getUpdateEmailPreferencesMutationOptions(options));
};

/**
 * Returns a presigned GCS URL for direct upload. The client sends JSON
metadata here, then uploads the file directly to the returned URL.

 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorEnvelope>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorEnvelope>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
